import React from 'react';
import Survey, { CssNames } from '../../Survey';
import Big5Survey from './big_five_60';
import BigFiveWrapper from './bigfive.styles';

class BigFiveSurvey extends React.Component {
  // state = { stage: 0, big5: null, matrix: null };
  //Define a callback methods on survey complete

  onComplete = async (survey, options) => {
    // Write survey results into database
    // console.log('Survey results: ');
    // const { data } = survey;
    // console.log(data);
    // await this.setState(prev => ({ big5: data, stage: prev.stage + 1 }));
    // console.log('Survey results:');
    const { data } = survey;
    const { onComplete } = this.props;
    const {
      BIG5_PAGE_01,
      BIG5_PAGE_02,
      BIG5_PAGE_03,
      BIG5_PAGE_04,
      BIG5_PAGE_05,
      BIG5_PAGE_06
    } = data;
    const parsed = {
      ...BIG5_PAGE_01,
      ...BIG5_PAGE_02,
      ...BIG5_PAGE_03,
      ...BIG5_PAGE_04,
      ...BIG5_PAGE_05,
      ...BIG5_PAGE_06
    };
    await onComplete(parsed);
  };

  render() {
    const Big5Model = new Survey.Model(Big5Survey);
    return (
      <BigFiveWrapper>
        <div className='edu_header'>
          <img
            className='edu-logo'
            src='https://res.cloudinary.com/dpveipnvx/image/upload/v1564630271/uaimetrics/uai_white.png'
            alt='edu-logo'
          />
        </div>
        <Survey.Survey
          model={Big5Model}
          css={CssNames}
          onComplete={this.onComplete}
        />
        <div className='Footer'>
          {/* <img
            src="https://res.cloudinary.com/dpveipnvx/image/upload/v1564629089/uaimetrics/Logo_edu-corporate-2.png"
            alt="edu-corporate"
          /> */}
          {/* <img
            className="btg-logo"
            src="https://res.cloudinary.com/dpveipnvx/image/upload/v1564629090/uaimetrics/BTG-Pactual-HP_Logo.jpg"
            alt="btg-pactual"
          /> */}
        </div>
        <div className='PushStickyFooter'></div>
        <div className='Plug'>
          <a
            href='http://www.edumetrics.cl/'
            target='_blank'
            rel='noopener noreferrer'
          >
            EduMetrics
          </a>
        </div>
      </BigFiveWrapper>
    );
  }
}

export default BigFiveSurvey;
